import React from 'react'
import { ContentTitle } from '../components/common/ContentTitle'
import { BasicLayout } from '../components/layouts/BasicLayout'

export const AccessForbidden = () => {
  return <BasicLayout contentTitle={<ContentTitle contentTitle="Access denied" />}></BasicLayout>
}
